import script from "./PageNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./PageNavigation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__